import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat, datePickerCommonOpts, paintWeekendColors } from './common/function';
import dayjs from 'dayjs';

function PayDetailList() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [pageRealtime, setPageRealtime] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [summary, setSummary] = useState([])
    const [listDataRealtime, setListDataRealtime] = useState([])
    const [listTrxDataRealtime, setListTrxDataRealtime] = useState([])
    const [combineDataRealtime, setCombineDataRealtime] = useState([])
    const [summaryRealtime, setSummaryRealtime] = useState([])
    const [reload, setReload] = useState(false)

    let tabList = ["익일", "즉결"]
    const [activeTab, setActiveTab] = useState("익일")
    const showSettlementHoldControls = false;

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    useEffect(() => {
        dispatch(change_Current_Location("상세정보"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setPreDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setNextDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수 (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "가맹점", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate])

    useEffect(() => {
        ListDataRealtime()
    }, [pageRealtime, maxFirstPage, reload, preDate, nextDate])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/settlement", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                salesCategory:
                    selectedValue == "가맹점" ? 0
                        : selectedValue == "지사" ? 1
                            : selectedValue == "총판" ? 2
                                : selectedValue == "대리점" ? 3
                                    : selectedValue == "영업자1" ? 4
                                        : selectedValue == "영업자2" ? 5
                                            : selectedValue == "영업자3" ? 6
                                                : "",
                salesValue: selectedText,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                setSummary(tmp?.data?.stateSummary[0] ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const ListDataRealtime = async () => {
        if (pageRealtime === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/settlement/realtime", {
            withCredentials: true,
            params: {
                page: pageRealtime,
                limit: maxFirstPage,
                salesCategory:
                    selectedValue == "가맹점" ? 0
                        : selectedValue == "지사" ? 1
                            : selectedValue == "총판" ? 2
                                : selectedValue == "대리점" ? 3
                                    : selectedValue == "영업자1" ? 4
                                        : selectedValue == "영업자2" ? 5
                                            : selectedValue == "영업자3" ? 6
                                                : "",
                salesValue: selectedText,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListDataRealtime(tmp?.data ?? [])
                setSummaryRealtime(tmp?.data?.stateSummary[0] ?? [])
                if (page === 1) {
                    setListTrxDataRealtime(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxDataRealtime((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        showSettlementHoldControls && { "no": 0, "text": "보류", "width": "50px", "textAlign": "center" },
        // { "no": 1, "text": "NO", "width": "70px", "textAlign": "center" },
        // { "no": 9, "text": "MID", "width": "90px", "textAlign": "center" },
        { "no": 3, "text": "상호", "width": "130px", "textAlign": "center" },
        { "no": 4, "text": "거래일", "width": "100px", "textAlign": "center" },
        { "no": 5, "text": "취소일", "width": "100px", "textAlign": "center" },
        // { "no": 5, "text": "정산형태", "width": "70px", "textAlign": "center" },
        { "no": 6, "text": "거래상태", "width": "70px", "textAlign": "center" },
        { "no": 7, "text": "거래금액", "width": "80px", "textAlign": "center" },
        { "no": 17, "text": "지사 수수료", "width": "120px", "textAlign": "center" },
        { "no": 18, "text": "총판 수수료", "width": "120px", "textAlign": "center" },
        { "no": 19, "text": "대리점 수수료", "width": "120px", "textAlign": "center" },
        { "no": 19, "text": "영업자1 수수료", "width": "120px", "textAlign": "center" },
        { "no": 19, "text": "영업자2 수수료", "width": "120px", "textAlign": "center" },
        { "no": 19, "text": "영업자3 수수료", "width": "120px", "textAlign": "center" },
        { "no": 11, "text": "수수료", "width": "120px", "textAlign": "center" },
        { "no": 13, "text": "정산금", "width": "80px", "textAlign": "center" },
        { "no": 14, "text": "결제서비스", "width": "80px", "textAlign": "center" },
        // { "no": 2, "text": "주문번호", "width": "200px", "textAlign": "center" },
    ].filter(Boolean);

    const [checkedIds, setCheckedIds] = useState([]);
    const [removedPendingIds, setRemovedPendingIds] = useState([]);

    useEffect(() => {
        if (!listTrxData) return;

        const tableBodyData = listTrxData.map((data) => {
            let up_data = JSON.parse(data.up_data);

            const formatFeeText = (data, indexFromLast) => {
                const item = data[data.length - indexFromLast];
                const fee_amt = Number(item?.fee_amt);
                const fee = Number(item?.fee);

                return isNaN(fee_amt) || isNaN(fee)
                    ? '-'
                    : `${changeNum(Math.round(fee_amt))}원 / ${fee.toFixed(2)}%`;
            };

            return [
                showSettlementHoldControls && {
                    no: 0,
                    text: (
                        data.realtime == "N" || data.confirm_status == "확정" ? (
                            <input
                                type="checkbox"
                                // 보류 상태면 removedPendingIds에 없을 때 체크,
                                // 아니면 checkedIds에 있을 때 체크
                                checked={
                                    data.confirm_status === '보류'
                                        ? !removedPendingIds.includes(data.id)
                                        : checkedIds.includes(data.id)
                                }
                                onChange={(e) => {
                                    const { checked } = e.target;

                                    if (data.confirm_status === '보류') {
                                        // 보류 항목 토글: 언체크 시 removedPendingIds에 추가, 체크 시 제거
                                        if (checked) {
                                            setRemovedPendingIds(prev => prev.filter(id => id !== data.id));
                                        } else {
                                            setRemovedPendingIds(prev =>
                                                prev.includes(data.id) ? prev : [...prev, data.id]
                                            );
                                        }
                                    } else {
                                        // 보류 아닌 항목: 기존 로직
                                        if (checked) {
                                            setCheckedIds(prev =>
                                                prev.includes(data.id) ? prev : [...prev, data.id]
                                            );
                                        } else {
                                            setCheckedIds(prev =>
                                                prev.filter(id => id !== data.id)
                                            );
                                        }
                                    }
                                }}
                            />
                        ) : (
                            ""
                        )
                    ),
                    width: "50px",
                    textAlign: "center",
                },
                // { no: 1, text: data.id, width: "70px", textAlign: "center" },
                // { no: 9, text: data.mid, width: "90px", textAlign: "center" },
                { no: 3, text: data.co_nm, width: "130px", textAlign: "left" },
                { no: 4, text: data.trx_date ? convertDateFormat(data.trx_date) : '-', width: "100px", textAlign: "center" },
                { no: 5, text: data.cancel_date ? convertDateFormat(data.cancel_date) : '-', width: "100px", textAlign: "center" },
                // { no: 5, text: data.realtime === 'N' ? "익일" : "즉결", width: "70px", textAlign: "center" },
                { no: 6, text: data.state === '1' ? "승인" : data.state === '3' ? "매입 후 취소" : "취소", width: "70px", textAlign: "center" },
                { no: 7, text: `${changeNum(Number(data.amt))}원`, width: "80px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 1), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 2), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 3), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 4), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 5), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 6), width: "120px", textAlign: "right" },
                { no: 11, text: `${changeNum(Number(data.fee))}원 / ${Number(data.fee_rate).toFixed(2)}%`, width: "120px", textAlign: "right" },
                { no: 13, text: `${changeNum(Number(data.settlement_amt))}원`, width: "80px", textAlign: "right" },
                { no: 14, text: data.payment_type, width: "80px", textAlign: "center" },
                // { no: 2, text: data.order_id, width: "200px", textAlign: "center" },
            ].filter(Boolean);
        });

        setCombineData(tableBodyData);
    }, [listTrxData, checkedIds, removedPendingIds]);
    
    useEffect(() => {
        if (!listTrxDataRealtime) return;

        const tableBodyData = listTrxDataRealtime.map((data) => {
            let up_data = JSON.parse(data.up_data);

            const formatFeeText = (data, indexFromLast) => {
                const item = data[data.length - indexFromLast];
                const fee_amt = Number(item?.fee_amt);
                const fee = Number(item?.fee);

                return isNaN(fee_amt) || isNaN(fee)
                    ? '-'
                    : `${changeNum(Math.round(fee_amt))}원 / ${fee.toFixed(2)}%`;
            };

            return [
                showSettlementHoldControls && {
                    no: 0,
                    text: "",
                    width: "50px",
                    textAlign: "center",
                },
                // { no: 1, text: data.id, width: "70px", textAlign: "center" },
                // { no: 9, text: data.mid, width: "90px", textAlign: "center" },
                { no: 3, text: data.co_nm, width: "130px", textAlign: "left" },
                { no: 4, text: data.trx_date ? convertDateFormat(data.trx_date) : '-', width: "100px", textAlign: "center" },
                { no: 5, text: data.cancel_date ? convertDateFormat(data.cancel_date) : '-', width: "100px", textAlign: "center" },
                // { no: 5, text: data.realtime === 'N' ? "익일" : "즉결", width: "70px", textAlign: "center" },
                { no: 6, text: data.state === '1' ? "승인" : data.state === '3' ? "매입 후 취소" : "취소", width: "70px", textAlign: "center" },
                { no: 7, text: `${changeNum(Number(data.amt))}원`, width: "80px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 1), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 2), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 3), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 4), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 5), width: "120px", textAlign: "right" },
                { no: 17, text: formatFeeText(up_data, 6), width: "120px", textAlign: "right" },
                { no: 11, text: `${changeNum(Number(data.fee))}원 / ${Number(data.fee_rate).toFixed(2)}%`, width: "120px", textAlign: "right" },
                { no: 13, text: `${changeNum(Number(data.settlement_amt))}원`, width: "80px", textAlign: "right" },
                { no: 14, text: data.payment_type, width: "80px", textAlign: "center" },
                // { no: 2, text: data.order_id, width: "200px", textAlign: "center" },
            ].filter(Boolean);
        });

        setCombineDataRealtime(tableBodyData);
    }, [listTrxDataRealtime]);

    const ChangeCheckStatus = () => {
        if (window.confirm("저장하시겠습니까?") === true) {
            onChangeCheckStatus(checkedIds, 9)
            onChangeCheckStatus(removedPendingIds, 0)
        }
    }

    const onChangeCheckStatus = async (arr, n) => {
        await axios.post(process.env.REACT_APP_API + "/api/settlement/confirm-status/bulk", {
            id: arr,
            confirmStatus: n
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data

            if (tmp?.code < 2000) {
                if (n === 9) {
                    setCheckedIds([])
                }
                else if (n === 0) {
                    setRemovedPendingIds([])
                }
                setReload(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
        });
    }

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const observerRefRealtime = useRef(null);
    useEffect(() => {
        if (combineDataRealtime.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listDataRealtime.totCnt >= pageRealtime * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPageRealtime((prev) => prev + 1);
            }
        });

        if (observerRefRealtime.current) {
            observer.observe(observerRefRealtime.current);
        }

        return () => {
            if (observerRefRealtime.current) {
                observer.unobserve(observerRefRealtime.current);
            }
        };
    }, [combineDataRealtime]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit
                        startInputRef={startInputRef}
                        endInputRef={endInputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={false}
                        state={true}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} placeholder={"ID & 이름 검색"} />}
                </form>
            </div>

            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>지사 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(summary?.level1_sum ?? 0)}원`} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>총판 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(summary?.level2_sum ?? 0)}원`} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>대리점 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(summary?.level3_sum ?? 0)}원`} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>영업자1 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(summary?.level4_sum ?? 0)}원`} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>영업자2 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(summary?.level5_sum ?? 0)}원`} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>영업자3 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${changeNum(summary?.level6_sum ?? 0)}원`} readonly="" disabled="" />
                        </div>
                    </div>
                    {/* <div className='excel-disable'>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                    </div> */}
                </div>
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer"
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        {showSettlementHoldControls && (
                            <div className="button_wrap" style={{ marginTop: "0px" }}>
                                <button onClick={() => { ChangeCheckStatus() }} id="tabulator-html-filter-go" name="searchPayBtn" type="button" className="btn btn-primary searchPayBtn" style={{ height: "30px" }}
                                    disabled={activeTab == "익일" ? false : true}>저장</button>
                            </div>
                        )}
                    </div>
                    <div className='excel-disable'>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                    </div>
                </div>
                {
                    activeTab == "익일"
                        ?
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.totCnt ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            spinner={spinner}
                            height={"700px"}
                        />
                        :
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listDataRealtime?.totCnt ?? 0}
                            filter_tableBodyData={combineDataRealtime}
                            page={pageRealtime}
                            setPage={setPageRealtime}
                            maxFirstPage={maxFirstPage}
                            observerRef={observerRefRealtime}
                            nonePage={false}
                            scrollState={true}
                            spinner={spinner}
                            height={"700px"}
                        />
                }
            </div>
        </div>
    )
}

export default PayDetailList
